import { Image } from '@akinon/next/components';
import { useLocalization, useMediaQuery } from '@akinon/next/hooks';
import { Link } from '@theme/components';
import { formatLocalizedDate } from '@theme/utils/parse-localized-date';
import React, { useEffect, useState } from 'react'

function BlogItem({blog}) {
  const { locale, t } = useLocalization();
  const safeLocale = locale === 'tr' ? 'tr' : 'en';
  const isMobile = useMediaQuery('(max-width: 768px)');

  function useMounted() {
    const [mounted, setMounted] = useState(false);
    useEffect(() => {
      setMounted(true);
    }, []);
    return mounted;
  }

  const isMounted = useMounted();

  const dateStr = isMounted
    ? formatLocalizedDate(blog?.value?.date, safeLocale, isMobile ? 'D MMM YYYY' : 'D MMMM YYYY')
    : formatLocalizedDate(blog?.value?.date, safeLocale, 'D MMMM YYYY');

  return (
    <div>
      <Link
          href={blog.value.more_button_url}
        >
        <Image
          src={blog?.kwargs?.value?.blog_image?.url}
          alt={blog?.value?.title || 'Yatsan Blog'}
          width={400}
          height={400}
          imageClassName="w-full h-full aspect-square object-cover"
          aspectRatio={400 / 400}
          draggable={false}
          sizes="400px"
          className="w-full h-auto mb-6 aspect-square"
        />
      </Link>
      <div className='flex justify-between text-sm mb-4 text-gray'>
        <div className='whitespace-nowrap'>
          {dateStr}
        </div>
        <div className='flex gap-x-1 whitespace-nowrap'>
          {blog?.value?.reading_time} {t('common.blog.minutes')}
          <span className='hidden lg:block'>
            {t('common.blog.reading')}
          </span>
        </div>
      </div>

      {blog?.value?.title && (
        <h3 className='font-medium text-lg leading-[110%] mb-4 line-clamp-4 h-20 block lg:line-clamp-2 lg:h-10 text-ellipsis'>
          <Link
            href={blog.value.more_button_url}
          >
            {blog?.value?.title}
          </Link>
        </h3>
      )}


      {blog?.value?.summary && (
        <div className='hidden lg:flex'>
          <p className='text-base leading-[150%] mb-6 line-clamp-3'>{blog.value.summary}</p>
        </div>
      )}

      {blog?.value?.more_button_url && (
        <Link
          href={blog.value.more_button_url}
          className='inline-flex items-center justify-center border border-primary-black text-primary-black text-sm font-medium rounded-full px-6 h-10 hover:bg-primary-black hover:text-white transition-colors'
        >
          {t('common.blog.read_more')}
        </Link>
      )}
    </div>
  )
}

export default BlogItem;
